import React from "react";
import Banner from "../../Assets/Banner.jpeg"
import "./Main.css"

export default function Main() {


    return (
        <>
            <div className="main-container">
                <img className="banner-image" src={Banner} alt="Banner"/>
            </div>
        </>
    )
}